import { ContextualField } from '../../../models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const IsDependentGroupsIncluded: ContextualField = {
    modelName: 'includeDependent',
    propertyType: PropertyType.Boolean,
    label: 'Include dependent groups',
    placeholder: 'Include dependent groups',
    propertyName: 'isDependentGroupsIncludedProperty',
    icon: ['fa-calculator', 'fa-sitemap'],
    extraData: {
        subProperty: 'taskOptionsOverride'
    }
};